import { IEspRequest, IEspSponsorship, TEspSponsorshipStatus } from '../model/types'

export const getEspSponsorshipForPartner = (
  sponsorships: IEspSponsorship[],
  partnerId: string
): IEspSponsorship | null =>
  sponsorships.find((sponsorship) => sponsorship.partnerId === partnerId) ?? null

/**
 * Derives the partner's sponsorship status — it is never stored, so it cannot drift out
 * of sync with the underlying data. A pending *change* request does not affect the
 * status: the current sponsor stays active until the change is approved.
 */
export const getSponsorshipStatus = (
  partnerId: string,
  requests: IEspRequest[],
  sponsorships: IEspSponsorship[]
): TEspSponsorshipStatus => {
  const sponsorship = getEspSponsorshipForPartner(sponsorships, partnerId)

  if (sponsorship?.currentSponsor) {
    return 'active'
  }

  const hasPendingEnrollment = requests.some(
    (request) =>
      request.partnerId === partnerId &&
      request.type === 'enrollment' &&
      request.status === 'pending'
  )

  return hasPendingEnrollment ? 'pending' : 'notOnboarded'
}
